import { useState } from "react";
import Header from "./components/Header";
import Profile from "./components/Profile";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Scroll from "./components/Scroll";
import Certs from "./components/Certs";



function App() {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div className={darkMode && "dark"}>
      <Header darkMode={darkMode} setDarkMode={setDarkMode} />
      <main className="bg-white text-gray-900 dark:bg-gray-900 dark:text-white">
        <Scroll />
        <Profile />
        <Certs />
        <Projects />
        <Skills />
        <Contact />
      </main>
    </div>
  );
}

export default App;
